module.exports = __webpack_public_path__ + "5624bc6565c7db78efcc5106c6615d48.jpg";